import makeStyles from '@mui/styles/makeStyles'

export default makeStyles(theme => ({
  editor: {
    marginTop: theme.spacing(6),
    marginBottom: theme.spacing(4),
    minHeight: 320
  }
}))
